export default "__VITE_ASSET__827574c5__"